import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const AppWithProviders = () => {
  // If no Google client ID is configured, render without the provider
  if (!CLIENT_ID) return <App />;
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  );
};

root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
);
